import React from "react";
import { AxiosResponse } from "axios";
import DataGrid, {
    Pager,
    Paging,
    FilterRow,
    Column,
    Sorting,
    Editing,
    Lookup,
    PatternRule,
    RequiredRule,
    SearchPanel,
    FilterPanel,
    StateStoring,
    Export
} from "devextreme-react/data-grid";
import { LoadIndicator, LoadPanel, SelectBox } from "devextreme-react";
import MatrixService, { ProviderUploadMappingsGridRowItem } from "../../services/MatrixService";
import lookupService, { LookupTypeIndexes } from "../../services/LookupService";
import sharedUtils from "../grid/sharedUtilities";
import gridUtils from "../grid/GridUtilities";
import {
    OnRowUpdatingEvent,
    OnRowInsertingEvent,
    OnRowRemovingEvent,
    onEditCanceledEvent,
} from "../../types/DevExtremeTypes";
import periodMatrixFormUtil from "./PeriodMatrixFormUtil";
import CookieService, { DXGridCookieKeyTypes } from "../../services/CookieService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/pro-regular-svg-icons";
import CustomStore from 'devextreme/data/custom_store';
import { onExportingEvent } from "../../types/DevExtremeTypes";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";

//props
interface ProviderUploadMappingsGridProps { }

export interface ProviderUploadMappingsAddEditObjectItem {
    id: number;
    businessEntityId: number;
    shortName: string;
    legalName: string;
}
export interface LookupTypeItemGrid {
    id: number;
    value: string;
    parentMappingId: string;
}
// State
interface ProviderUploadMappingsGridState {
    mappingsGridDataSource: ProviderUploadMappingsGridRowItem[];
    showProgressIndicator: boolean;
    providerLookUp: LookupTypeItemGrid[];
    mappingsAddEditObject: ProviderUploadMappingsAddEditObjectItem;
    errorMessage: any[];
    loadPanelVisible: boolean;
    providerLookUpAll: LookupTypeItemGrid[];
    active: boolean;
}

// Component - displays the provider upload mappings Grid
class ProviderUploadMappingsGrid extends React.Component<ProviderUploadMappingsGridProps> {
    //Initialize the component's state.
    state: ProviderUploadMappingsGridState;
    rateService: MatrixService;
    sharedUtils: sharedUtils;
    dropdownService: lookupService;
    utils: periodMatrixFormUtil;
    gridUtils: gridUtils;
    constructor(props: ProviderUploadMappingsGridProps) {
        super(props);
        this.sharedUtils = new sharedUtils();
        this.rateService = new MatrixService();
        this.dropdownService = new lookupService();
        this.utils = new periodMatrixFormUtil();
        this.gridUtils = new gridUtils();
        // Initialize state and services/utils
        this.state = {
            mappingsGridDataSource: [],
            showProgressIndicator: false,
            providerLookUp: [],
            providerLookUpAll: [],
            mappingsAddEditObject: {
                id: 0,
                businessEntityId: 0,
                shortName: "",
                legalName: ''
            },
            errorMessage: [],
            loadPanelVisible: false,
            active: true,
        };
    }

    componentDidMount() {
        this.dropDownDataSource();
        this.providerMappingDataSource();
        //this.APIChaining()
    }

    dropDownDataSource = () => {
        // this.setState({
        //     showProgressIndicator: true,
        // });
        this.dropdownService
        .getLookupByLookupTypeIndex(LookupTypeIndexes.providerLegalNameLookup)
        .then(this.handleProviderLUSuccess)
        .catch(this.handleError);
    
        this.dropdownService
        .getLookupByLookupTypeIndexAll(LookupTypeIndexes.providerLegalNameLookup)
        .then(this.handleProviderLUAllSuccess)
        .catch(this.handleError);

    };

    providerMappingDataSource = () => {
        this.setState({
            showProgressIndicator: true,
        });
        this.rateService.getProviderUploadMappingDataItem().then(this.handleSuccess).catch(this.handleError);
    };

    // APIChaining = () => {
    //     this.setState({
    //         showProgressIndicator: true,
    //     }, () => {
    //         axios.all([

    //             this.dropdownService
    //                 .getLookupByLookupTypeIndex(LookupTypeIndexes.providerLegalNameLookup),
    //             this.dropdownService
    //                 .getLookupByLookupTypeIndexAll(LookupTypeIndexes.providerLegalNameLookup),
    //             this.rateService.getProviderUploadMappingDataItem()
    //         ]).then((responses) => {
    //             this.setState({
    //                 showProgressIndicator: false,
    //             }, () => {
    //                 if (responses && responses.length && responses.length > 0)
    //                     this.handleProviderLUSuccess(responses[0]);
    //                 if (responses && responses.length && responses.length > 1)
    //                     this.handleProviderLUAllSuccess(responses[1]);
    //                 if (responses && responses.length && responses.length > 2)
    //                     this.handleSuccess(responses[2])
    //             });
    //         }).catch((error) => {
    //             //this.handleError
    //             this.setState({
    //                 showProgressIndicator: false,
    //                 loadPanelVisible: false,
    //             });

    //         });
    //     });

    // }

    lookUpCreationSelect = (response: AxiosResponse<any>): LookupTypeItemGrid[] => {
        var itemLUItem: LookupTypeItemGrid;
        var itemLUItemArray: LookupTypeItemGrid[];
        var select: LookupTypeItemGrid = {
            id: 0,
            value: "select",
            parentMappingId: "",
        };
        itemLUItemArray = [];
        response.data.data.map((item: any, uniqueKey: number) => {
            itemLUItem = {
                id: parseInt(item.id),
                value: item.value,
                //value: item.id,
                parentMappingId: item.parentMappingId,
            };
            itemLUItemArray.push(itemLUItem);
        });
        return [select].concat(itemLUItemArray);
    };

    lookUpCreation = (response: AxiosResponse<any>): LookupTypeItemGrid[] => {
        var itemLUItem: LookupTypeItemGrid;
        var itemLUItemArray: LookupTypeItemGrid[];
        itemLUItemArray = [];
        response.data.data.map((item: any, uniqueKey: number) => {
            itemLUItem = {
                // id: parseInt(item.id),
                id: item.id,
                value: item.value,
                parentMappingId: item.parentMappingId,
            };
            itemLUItemArray.push(itemLUItem);
        });
        return itemLUItemArray;
    };

    handleProviderLUSuccess = (response: AxiosResponse<any>) => {
        // var providerDropDown = this.lookUpCreationSelect(response);
        var providerDropDown = this.lookUpCreation(response);
        this.setState({
            providerLookUp: providerDropDown,
            //providerLookUpAll: providerDropDown
        });
    };

    handleProviderLUAllSuccess = (response: AxiosResponse<any>) => {
        // var providerDropDown = this.lookUpCreationSelect(response);
        var providerDropDown = this.lookUpCreation(response);
        this.setState({
            providerLookUpAll: providerDropDown,
        });
    };

    handleSuccess = (response: AxiosResponse<any>) => {
        this.setState({
            mappingsGridDataSource: response.data.data,
            showProgressIndicator: false,
            loadPanelVisible: false,
        });
    };

    handleError = (error: AxiosResponse<any>) => {
        this.setState({
            showProgressIndicator: false,
            loadPanelVisible: false,
        });
        var respMessage: string = "Rate service failed with response: " + JSON.stringify(error);

        if (!this.rateService.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    };

    onRowUpadating = (e: OnRowUpdatingEvent) => {
        // var typeId: string =
        //     e.newData.idTypeLookUpId == undefined ? e.oldData.idTypeLookUpId : e.newData.idTypeLookUpId;
        // var typeValue: string = e.newData.idValue == undefined ? e.oldData.idValue : e.newData.idValue;
        // var typeId: string =
        //     e.newData.businessEntityId == undefined ? e.oldData.businessEntityId : e.newData.businessEntityId;
        // var typeValue: string = e.newData.legalName == undefined ? e.oldData.legalName : e.newData.legalName;
        // var name: string = e.newData.shortName == undefined ? e.oldData.shortName : e.newData.shortName;
        // Built locally so e.cancel can be set synchronously (setState callbacks run after this handler returns)
        const mappingsAddEditObject = {
            ...this.state.mappingsAddEditObject,
            id: e.oldData.id,
            businessEntityId:
                e.newData.businessEntityId ||
                    e.newData.businessEntityId === null ||
                    e.newData.businessEntityId === 0 ||
                    e.newData.businessEntityId === ""
                    ? e.newData.businessEntityId !== 0
                        ? e.newData.businessEntityId
                        : null
                    : e.oldData.businessEntityId !== 0
                        ? e.oldData.businessEntityId
                        : null,
            legalName:
                e.newData.legalName || e.newData.legalName === null || e.newData.legalName === ""
                    ? e.newData.legalName
                    : e.oldData.legalName,
            shortName:
                e.newData.shortName || e.newData.shortName === null || e.newData.shortName === ""
                    ? e.newData.shortName
                    : e.oldData.shortName,
        };
        this.setState({
            loadPanelVisible: true,
            errorMessage:[],
            mappingsAddEditObject: mappingsAddEditObject,
        });
        this.rateService
        .saveProviderUploadMappingDataItem(mappingsAddEditObject)
        .then(this.onRowUpdatedInsertedDeleted)
        .catch((err) => {
            this.setState({
                loadPanelVisible: false,
                errorMessage:
                    err.response && err.response.data && err.response.data.error
                        ? JSON.parse(JSON.stringify(err.response.data.error))
                        : null,
            });
        });

        var typeId = mappingsAddEditObject.businessEntityId;
        var typeValue = mappingsAddEditObject.legalName;
        var name = mappingsAddEditObject.shortName;
        e.cancel = this.addEditCancel(e, typeId, typeValue, name);

        
    };

    addEditCancel = (e: any, typeId: any, typeValue: any, name: any) => {
        var cancel: boolean = false;
        var isValid: boolean = this.utils.shortNameValidation(typeId, typeValue, name);
        // errorMessage is cleared by the caller just before this runs, so (as pre-batching) only validity matters
        if (!isValid) {
            cancel = true;
            // this.setState({
            //     errorMessage: [],
            // });
        } else {
            cancel = false;
            this.setState({
                errorMessage: [],
            });
        }
        return cancel;
    };

    onRowUpdatedInsertedDeleted = () => {
        this.setState({
            // loadPanelVisible: false,
            errorMessage: [],
        });
        this.rateService.getProviderUploadMappingDataItem().then(this.handleSuccess).catch(this.handleError);
    };

    onRowInserting = (e: OnRowInsertingEvent) => {
        // Built locally so e.cancel can be set synchronously (setState callbacks run after this handler returns)
        const mappingsAddEditObject = {
            ...this.state.mappingsAddEditObject,
            id: 0,
            businessEntityId:
                e.data.businessEntityId !== 0 ? e.data.businessEntityId : null,
            shortName: e.data.shortName ? e.data.shortName : "",
            legalName: e.data.legalName ? e.data.legalName : "",
        };
        this.setState({
            active: true,
            loadPanelVisible: true,
            errorMessage:[],
            mappingsAddEditObject: mappingsAddEditObject,
        });
        //e.cancel = true;
        this.rateService
        .saveProviderUploadMappingDataItem(mappingsAddEditObject)
        .then(()=>{
            //e.cancel = false;
            this.onRowUpdatedInsertedDeleted();
        })
        .catch((err) => {
            this.setState({
                loadPanelVisible: false,
                errorMessage:
                    err.response && err.response.data && err.response.data.error
                        ? JSON.parse(JSON.stringify(err.response.data.error))
                        : null,
            },()=>{
                //e.cancel = this.addEditCancel(e,this.state.mappingsAddEditObject.businessEntityId,this.state.mappingsAddEditObject.legalName,this.state.mappingsAddEditObject.shortName);
           });
        });
        e.cancel = this.addEditCancel(
            e,
            mappingsAddEditObject.businessEntityId,
            mappingsAddEditObject.legalName,
            mappingsAddEditObject.shortName
        );

        
    };

    onRowRemoving = (e: OnRowRemovingEvent) => {
        this.rateService
            .deleteProviderUploadMappingDataItem(e.data.id)
            .then(this.onRowUpdatedInsertedDeleted)
            .catch(this.handleError);
    };

    onEditCancelled = (e: onEditCanceledEvent) => {
        this.setState({
            errorMessage: [],
        });
    };

    renderErrorMessage = (errorMessage: any[]) => {
        let errorData: React.ReactNode = <></>;
        if (errorMessage) {
            errorData = (
                <span className="unscheduled-shift">
                    <ul>
                        {errorMessage.map((item: any, uniqueKey: number) => {
                            return (
                                <li key={uniqueKey}>
                                    {item.columnName}: {item.errorMessage}
                                </li>
                            );
                        })}
                    </ul>
                </span>
            );
        }
        return errorData;
    };
    onRowEditting = () => {
        this.setState({
            active: false,
            errorMessage:[]
        });
    };
    onRowAdding = () => {
        this.setState({
            active: true,
            errorMessage:[]
        });
    };
    onEditorPreparing = (editEvent: any) => {
        // const currentDataField = editEvent.dataField;
        // const caption = editEvent.caption;
        // const currentRow = editEvent.row;
        // if (currentDataField == 'providerBusinessEntityId' && caption.toLowerCase() == 'provider') {
        //     editEvent.editorName = 'dxLookupTypeListDynamic';
        //     editEvent.editorOptions.dataSource = this.state.active ? this.state.providerLookUp : this.state.providerLookUpAll;
        //     editEvent.editorOptions.displayExpression = 'value';
        //     editEvent.editorOptions.parentMappingId = '';
        //     //editEvent.editorOptions.isRoot = true;
        //     editEvent.editorOptions.onValueChanged = function (args:any) {  // Override the default handler
        //         console.log(currentRow);
        //     }

        // }
        //One of "dataRow", "filterRow", "headerRow" or "searchPanel".
        //console.log(editEvent.parentType,'editEvent.parentType');
        if (editEvent.parentType === "filterRow" && editEvent.dataField === "businessEntityId" && editEvent.caption?.toLowerCase() == 'provider') {
            editEvent.editorName = "dxTextBox"
            editEvent.editorOptions.valueChangeEvent = "keyup";
            // editEvent.editorOptions.calculateFilterExpression = function calculateFilterExpression(filterValue:any, selectedFilterOperation:any, target:any){
            //     alert(target);
 
            // }
        }

    }

    onExporting = (e: onExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
            });
        });
        e.cancel = true;
    }
    
    setProviderCellValue = (rowData: any, value: any) => {
        //value = rowData.businessEntityId;
        let filtered = this.state.active ? this.state.providerLookUp.filter(a => a.id == value) : this.state.providerLookUpAll.filter(a => a.id == value)
        if (filtered && filtered.length) {
            let id = filtered[0].id;
            let name = filtered[0].value;
            rowData.businessEntityId = id === 0 ? null : id;
            rowData.legalName = name;
        }
        //rowData.businessEntityId = value === 0 ? null : value;
    };

    setProviderCellComponent = (cellInfo: any) => {
        return (
            <div>
                {cellInfo.data.legalName}
                {"  "}
            </div>
        );
    };

    onCustomGridLoad() {
        return CookieService.loadDXGridConfiguration(DXGridCookieKeyTypes.providerUploadMapping);
    }

    onCustomGridSave(gridState: Object) {
        CookieService.saveDXGridConfiguration(DXGridCookieKeyTypes.providerUploadMapping, gridState);
    }

    // getlookupDataSourceConfig1 = () => {
    //     let obj = {
    //         store: {
    //             type: 'array',
    //             data: this.state.active ? this.state.providerLookUp : this.state.providerLookUpAll,
    //             //sort:'value'
    //             //key:'value'
    //         },
    //         //sort:['value'],
    //         pageSize: 10,
    //         paginate: true
    //     }
    //     return obj;
    // }

    getlookupDataSourceConfig = () =>{
        let config = {
            store: new CustomStore({
                //key: "id",
                loadMode: "raw",
                load: () => {
                    return this.state.active ? this.state.providerLookUp : this.state.providerLookUpAll;
                }
            }),
            // sort: "name",
            pageSize: 10,
            paginate: true
        };
        return config;
    }

    calculateFilterExpression(this:any,filterValue:any, selectedFilterOperation:any, target:any){
        // // Invoke the default implementation for other filter operations
        // if(!this.defaultCalculateFilterExpression) 
        //     return [this.dataField, 'contains', filterValue];  
        // // return this.defaultCalculateFilterExpression.apply(this, arguments);

        //            return this.defaultCalculateFilterExpression.apply(this, arguments);
        
        //filterBuilder
        if (target == "filterRow" && this.caption?.toLowerCase() == 'provider') {
            if(selectedFilterOperation){
                //let filterExpression = [['legalName',selectedFilterOperation,filterValue],'or',[this.dataField,selectedFilterOperation,filterValue]]
                let filterExpression = ['legalName',selectedFilterOperation,filterValue]
                return [filterExpression];
            }
            return this.defaultCalculateFilterExpression?.apply(this, arguments);
        }
        return this.defaultCalculateFilterExpression?.apply(this, arguments);
        //return this.defaultCalculateFilterExpression?.apply(this, arguments);
    }
    
    calculateSortValue(this:any,data:any) {
        return data.legalName;
    }
    // calculateCellValue = (data: any) => {
    //     let name = 'select';
    //     let id = 0;
    //     let filtered = this.state.providerLookUp.filter((a: any) => a.id == data.businessEntityId)
    //     if (filtered && filtered.length) {
    //         name = filtered[0].value;
    //         id = filtered[0].id;
    //     }
    //     filtered = this.state.providerLookUpAll.filter((a: any) => a.id == data.businessEntityId)
    //     if (filtered && filtered.length) {
    //         name = filtered[0].value;
    //         id = filtered[0].id;
    //     }
    //     return name;
    // }

    
    render() {
        var { errorMessage, loadPanelVisible } = this.state;
        return (
            <div>
                <h2 className="page-title__black-table">Provider Upload Mappings</h2>
                {this.renderErrorMessage(errorMessage)}
                {this.state.showProgressIndicator ? (
                    <div className="starter-template">
                        <LoadIndicator
                            id="simple-grid-indicator"
                            height={100}
                            width={100}
                            visible={this.state.showProgressIndicator}
                        />
                    </div>
                ) : (
                    <>
                        <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={loadPanelVisible} />
                        <DataGrid
                            dataSource={this.state.mappingsGridDataSource}
                            showBorders={false}
                            showColumnLines={false}
                            hoverStateEnabled={true}
                            columnAutoWidth={true}
                            allowColumnReordering={true}
                            onRowUpdating={this.onRowUpadating}
                            onRowInserting={this.onRowInserting}
                            onRowRemoving={this.onRowRemoving}
                            onEditCanceling={this.onEditCancelled}
                            onEditingStart={this.onRowEditting}
                            onInitNewRow={this.onRowAdding}
                            onEditorPreparing={this.onEditorPreparing}
                            allowColumnResizing={true}
                            columnResizingMode={"widget"}
                            onExporting={this.onExporting}
                        >
                            <Export enabled={true} />
                            <SearchPanel visible={true} placeholder={"Search"} />
                            <Sorting mode="single" />
                            <FilterPanel visible={false} />
                            <Paging defaultPageSize={10} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />
                            <Editing
                                mode="row"
                                useIcons={true}
                                allowAdding={true}
                                allowUpdating={true}
                                allowDeleting={true}
                            />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={this.onCustomGridLoad}
                                customSave={this.onCustomGridSave}
                                savingTimeout={0}
                            />
                            <Column type="buttons" buttons={["edit", "delete"]} />
                            {/* <Column dataField="id" allowSorting={true} caption="ID" allowEditing={false} calculateSortValue={(rowData: any) => {
                                return this.gridUtils.convertStringToInt(rowData.id);
                            }} /> */}
                            <Column dataField="id" caption="ID" allowEditing={false} cssClass='grid-column-padding'></Column>
                            <Column
                                dataField="businessEntityId"
                                name='provider'
                                allowSorting={true}
                                caption="PROVIDER"
                                setCellValue={this.setProviderCellValue}
                                cellRender={this.setProviderCellComponent}
                                filterOperations={[ "contains", "notcontains", "startswith", "endswith", "=", "<>" ]}
                                calculateFilterExpression={this.calculateFilterExpression}
                                calculateSortValue={this.calculateSortValue}
                                //calculateCellValue={this.calculateCellValue}
                                dataType="string"
                                //editorOptions={"{searchExpr:['value']}"}
                            >
                                <Lookup
                                    dataSource={this.getlookupDataSourceConfig()}
                                    displayExpr="value"
                                    valueExpr="id"
                                />
                            </Column>
                            <Column
                                dataField="businessEntityId"
                                name='providerID'
                                allowSorting={true}
                                caption="PROVIDER ID"
                                allowEditing={false}
                                calculateSortValue={(rowData: any) => {
                                    return this.gridUtils.convertStringToInt(rowData.businessEntityId);
                                }}>
                                    <RequiredRule/>
                            </Column>
                            <Column dataField="shortName" allowSorting={true} caption="MAPPING NAME">
                            <RequiredRule/>
                            </Column>
                            <Column
                                dataField="lastUpdatedOn"
                                allowSorting={true}
                                caption="LAST UPDATED ON"
                                allowEditing={false}
                            />
                            <Column
                                dataField="lastUpdatedBy"
                                allowSorting={true}
                                caption="LAST UPDATED BY"
                                allowEditing={false}
                            />
                            <FilterRow visible={true} applyFilter="auto" />
                        </DataGrid>
                    </>
                )}
            </div>
        );
    }
}

export default ProviderUploadMappingsGrid;
